import { useState, useEffect, useRef } from "react";
import styles from "./NavigationProgressBar.module.css";

let globalStart = null;
let globalComplete = null;

const NavigationProgressBar = () => {
  const [phase, setPhase] = useState("idle");
  const timerRef = useRef(null);

  useEffect(() => {
    globalStart = () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      setPhase("start");
      timerRef.current = setTimeout(() => {
        setPhase("loading");
      }, 50);
    };
    globalComplete = () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      setPhase("complete");
      timerRef.current = setTimeout(() => {
        setPhase("idle");
      }, 400);
    };
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  if (phase === "idle") return null;

  return <div className={`${styles.progressBar} ${styles[phase]}`} />;
};

export const triggerProgress = () => {
  if (globalStart) globalStart();
  requestAnimationFrame(() => {
    setTimeout(() => {
      if (globalComplete) globalComplete();
    }, 200);
  });
};

export default NavigationProgressBar;
